import { render, staticRenderFns } from "./Paginate.vue?vue&type=template&id=71ff47e2&scoped=true&"
import script from "./Paginate.vue?vue&type=script&lang=js&"
export * from "./Paginate.vue?vue&type=script&lang=js&"
import style0 from "./Paginate.vue?vue&type=style&index=0&id=71ff47e2&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ff47e2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71ff47e2')) {
      api.createRecord('71ff47e2', component.options)
    } else {
      api.reload('71ff47e2', component.options)
    }
    module.hot.accept("./Paginate.vue?vue&type=template&id=71ff47e2&scoped=true&", function () {
      api.rerender('71ff47e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2sh5mi9b4R3kc/JS/comp/Paginate.vue"
export default component.exports